import * as sentry from '@sentry/react';

const captureException = (error) => {
  sentry.captureException(error);
};

export { captureException };
